export const getTotalPagesResolved = async (): Promise<number> => {
  const result = await chrome.storage.local.get(["cookieBlockerTotal"]);
  const value = result.cookieBlockerTotal;

  // Check if the retrieved value is a valid number.
  // If it's not a number type, or if it is NaN, return 0.
  if (typeof value !== "number" || Number.isNaN(value)) {
    return 0;
  } else {
    // Otherwise, return the valid number.
    return value;
  }
};
